import { render } from "./AppMain.vue?vue&type=template&id=52f8ee73&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"

import "./AppMain.vue?vue&type=style&index=0&id=52f8ee73&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52f8ee73"

export default script